import classes from "./Loader.module.css";

const Loader = function () {
  return (
    <div className={classes.loader}>
      <div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
